export const statusNotifications = [
  'Внимание! При переводе заявки в некоторые статусы некоторые данные могут быть потеряны!',
  'После перевода заявки в статус “Дубликат” возможность изменения статуса будет утеряна.',
]

export const paymentNotifications = [
  'При измении типа оплаты убедитесь в том, что поля “Тип оплаты”, “Причина обращения” и поля адреса установки оборудования соответствуют друг другу.',
  'Вы не сможете изменить тип оплаты у заявки на тип “Полная дотация”, если адрес  не соответствует списку дотационных регионов.',
]

export const installationsNotifications = [
  'Внимание! Изменение ID-оборудования может привести к тому, что у Абонента будет отключено вещание каналов!',
]

export const installationsNotificationsFull = [
  'Внимание! Изменение ID-оборудования может привести к тому, что у Абонента будет отключено вещание каналов!',
  'Дата установки оборудования должна соответствовать дате Акта, подписанного Абонентом. Неверное изменение Даты установки может привести к тому, что отредактировать заявку в дальнейшем будет невозможно!',
]
